webpackJsonp([15,13],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(8);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueResource = __webpack_require__(13);
	
	var _vueResource2 = _interopRequireDefault(_vueResource);
	
	var _vueRouter = __webpack_require__(376);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _routers = __webpack_require__(94);
	
	var _routers2 = _interopRequireDefault(_routers);
	
	var _store = __webpack_require__(98);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _fastclick = __webpack_require__(281);
	
	var _fastclick2 = _interopRequireDefault(_fastclick);
	
	var _netError = __webpack_require__(380);
	
	var _netError2 = _interopRequireDefault(_netError);
	
	var _loading = __webpack_require__(378);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	var _mfyLoading = __webpack_require__(379);
	
	var _mfyLoading2 = _interopRequireDefault(_mfyLoading);
	
	var _toast = __webpack_require__(381);
	
	var _toast2 = _interopRequireDefault(_toast);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// loading
	
	// 注册全局组件
	// loading
	
	// 引入公共组件
	_vue2.default.component('netError', _netError2.default);
	_vue2.default.component('loading', _loading2.default); // loading
	_vue2.default.component('myfLoading', _mfyLoading2.default);
	_vue2.default.component('toast', _toast2.default);
	
	__webpack_require__(71);
	
	_vue2.default.use(_vueRouter2.default);
	_vue2.default.use(_vueResource2.default);
	
	// 实例化VueRouter
	var router = new _vueRouter2.default({
	    // mode: 'history',
	    routes: _routers2.default
	});
	_fastclick2.default.attach(document.body);
	
	// 登录中间验证，页面需要登录而没有登录的情况直接跳转登录
	router.beforeEach(function (to, from, next) {
	    next();
	});
	
	var vm = new _vue2.default({
	    router: router,
	    store: _store2.default
	}).$mount('#app');
	
	// 请求api接口时，增加请求前的交互，如显示loading状态（在next前），请求后的的交互，如隐藏loading状态，在next的回调方法里面加--lk
	_vue2.default.http.interceptors.push(function (request, next) {
	    vm.$store.dispatch('LOADING', true);
	    next(function (res) {
	        if (res.ok || !res.ok) {
	            vm.$store.dispatch('LOADING', false);
	        }
	    });
	});

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 71:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 72:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 94:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var routers = [
	// 测试专用,最后将会删除
	{
	    path: '/test',
	    name: 'test',
	    component: function component(resolve) {
	        __webpack_require__.e/* nsure */(0, function () {
	            resolve(__webpack_require__(33));
	        });
	    }
	},
	// 消息中心页面 -- yy
	{
	    path: '/inboxInfo',
	    name: 'inboxInfo',
	    component: function component(resolve) {
	        __webpack_require__.e/* nsure */(8, function () {
	            resolve(__webpack_require__(78));
	        });
	    }
	},
	// 消息中心--通知页面--yy
	{
	    path: '/inboxInform',
	    name: 'inboxInform',
	    component: function component(resolve) {
	        __webpack_require__.e/* nsure */(6, function () {
	            resolve(__webpack_require__(79));
	        });
	    }
	},
	// 消息中心--活动页面--yy
	{
	    path: '/inboxActive',
	    name: 'inboxActive',
	    component: function component(resolve) {
	        __webpack_require__.e/* nsure */(0/* duplicate */, function () {
	            resolve(__webpack_require__(33));
	        });
	    }
	},
	// 统一入口--常见问题--yy
	{
	    path: '/commonQuest',
	    name: 'commonQuest',
	    component: function component(resolve) {
	        __webpack_require__.e/* nsure */(7, function () {
	            resolve(__webpack_require__(82));
	        });
	    }
	},
	// 统一入口--用户反馈--yy
	{
	    path: '/feedBack',
	    name: 'feedBack',
	    component: function component(resolve) {
	        __webpack_require__.e/* nsure */(11, function () {
	            resolve(__webpack_require__(84));
	        });
	    }
	},
	// 统一入口--试算器详情页--yy
	{
	    path: '/applianceDetail',
	    name: 'applianceDetail',
	    component: function component(resolve) {
	        __webpack_require__.e/* nsure */(5, function () {
	            resolve(__webpack_require__(81));
	        });
	    }
	},
	// 统一入口--选择城市页--yy
	{
	    path: '/cityList',
	    name: 'cityList',
	    component: function component(resolve) {
	        __webpack_require__.e/* nsure */(12, function () {
	            resolve(__webpack_require__(77));
	        });
	    }
	},
	// 统一入口--家电套购--yy
	{
	    path: '/appliance',
	    name: 'appliance',
	    component: function component(resolve) {
	        __webpack_require__.e/* nsure */(1, function () {
	            resolve(__webpack_require__(80));
	        });
	    }
	},
	// 统一入口--消费首页--yy
	/* {
	    path: '/custom',
	    name: 'custom',
	    component(resolve) {
	        require.ensure(['./views/unifiedEntrance/custom.vue'], () => {
	            resolve(require('./views/unifiedEntrance/custom.vue'));
	        });
	    }
	}, */
	// 统一入口--app下载页--yy
	{
	    path: '/download',
	    name: 'download',
	    component: function component(resolve) {
	        __webpack_require__.e/* nsure */(9, function () {
	            resolve(__webpack_require__(83));
	        });
	    }
	},
	// 统一入口--商品分期详情--yy
	{
	    path: '/installmentDetail',
	    name: 'installmentDetail',
	    component: function component(resolve) {
	        __webpack_require__.e/* nsure */(10, function () {
	            resolve(__webpack_require__(86));
	        });
	    }
	},
	// 统一入口--商品分期--yy 备注:由于代码的变更, 导致installment现在司机指向的地址是 installmentList
	{
	    path: '/installment',
	    name: 'installment',
	    component: function component(resolve) {
	        __webpack_require__.e/* nsure */(4, function () {
	            resolve(__webpack_require__(87));
	        });
	    }
	},
	// 统一入口--商品分期--yy 次级目录
	{
	    path: '/installmentList',
	    name: 'installmentList',
	    component: function component(resolve) {
	        __webpack_require__.e/* nsure */(2, function () {
	            resolve(__webpack_require__(85));
	        });
	    }
	},
	// 统一入口--美易分介绍页--liudg-20171229
	{
	    path: '/myfDetail',
	    name: '美易分介绍页',
	    component: function component(resolve) {
	        __webpack_require__.e/* nsure */(3, function () {
	            resolve(__webpack_require__(88));
	        });
	    }
	}];
	
	exports.default = routers;

/***/ }),

/***/ 95:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	/**
	 * Created by zxh on 2016/12/26.
	 */
	
	exports.default = {
	    LOADING: function LOADING(_ref, bool) {
	        var commit = _ref.commit;
	        // 更新载入界面状态
	        commit('LOADING', bool);
	    },
	    NET_ERROR: function NET_ERROR(_ref2, bool) {
	        var commit = _ref2.commit;
	        // 设置网络状态
	        commit('NET_ERROR', bool);
	    },
	
	    // 设置将vuex的对象(localStorage和sessionStorage)存储或者取出
	    // @param bool : true: 将local和session里的对象取出到vuex中
	    //               false: 将vuex中的对象存储起来
	    RECOVERY_TO_VUEX_UNIONLOGIN: function RECOVERY_TO_VUEX_UNIONLOGIN(_ref3, bool) {
	        var commit = _ref3.commit;
	
	        commit('RECOVERY_TO_VUEX_UNIONLOGIN', bool);
	    }
	};

/***/ }),

/***/ 96:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _defineProperty2 = __webpack_require__(165);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _types$LOADING$types$; /**
	                            * Created by Administrator on 2016/12/26.
	                            */
	
	
	var _mutationsType = __webpack_require__(97);
	
	var types = _interopRequireWildcard(_mutationsType);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (_types$LOADING$types$ = {}, (0, _defineProperty3.default)(_types$LOADING$types$, types.LOADING, function (state, bool) {
	    // 对多个接口请求进行计数处理,防止一个接口成功导致loading界面直接停掉
	    if (bool === true) {
	        ++state.loadingTimes;
	    } else if (bool === false) {
	        --state.loadingTimes;
	    }
	    if (state.loadingTimes < 0) {
	        state.loadingTimes = 0; // 防止异常
	    }
	    if (state.loadingTimes > 0) {
	        state.loadingShow = true;
	    } else {
	        state.loadingShow = false;
	    }
	}), (0, _defineProperty3.default)(_types$LOADING$types$, types.NET_ERROR, function (state, bool) {
	    state.isNetErr = bool;
	}), (0, _defineProperty3.default)(_types$LOADING$types$, types.RECOVERY_TO_VUEX_UNIONLOGIN, function (state, bool) {
	    if (bool === true) {
	        if (state.IS_FRESH === true) {
	            state.IS_FRESH = true;
	        }
	    }
	}), _types$LOADING$types$);

/***/ }),

/***/ 97:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * Created by Administrator on 2016/12/26.
	 */
	var LOADING = exports.LOADING = 'LOADING'; // 设置是否显示载入界面
	var NET_ERROR = exports.NET_ERROR = 'NET_ERROR'; // 设置网络是否错误
	var RECOVERY_TO_VUEX_UNIONLOGIN = exports.RECOVERY_TO_VUEX_UNIONLOGIN = 'RECOVERY_TO_VUEX_UNIONLOGIN';

/***/ }),

/***/ 98:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _vue = __webpack_require__(8);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(377);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	var _mutations = __webpack_require__(96);
	
	var _mutations2 = _interopRequireDefault(_mutations);
	
	var _actions = __webpack_require__(95);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import filters from '../filters';
	
	/**
	 * Created by Administrator on 2016/12/26.
	 */
	_vue2.default.use(_vuex2.default);
	
	var state = {
	    id: 1, // 页面跳转（个人中心页的）
	    IS_FRESH: true, // 刷新标志,默认设置为true,从登录页面进入时会设置为false
	    loadingShow: false, // 是否显示载入界面
	    loadingTimes: 0, // 对loading请求进行计数,防止当有多个接口请求时,一个请求成功就会导致loading界面结束
	    isNetErr: false
	};
	
	exports.default = new _vuex2.default.Store({
	    state: state,
	    mutations: _mutations2.default,
	    // getters,
	    actions: _actions2.default
	});

/***/ }),

/***/ 109:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	//
	//
	//
	//
	//
	//
	//
	//
	
	__webpack_require__(72);
	// require('../../assets/scss/common/reset.scss');
	
	exports.default = {
	    computed: {
	        loadingShow: function loadingShow() {
	            return this.$store.state.loadingShow;
	        }
	    }
	};

/***/ }),

/***/ 110:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	__webpack_require__(72);
	__webpack_require__(3);
	
	exports.default = {
	    computed: {
	        loadingShow: function loadingShow() {
	            return this.$store.state.loadingShow;
	        }
	    }
	};

/***/ }),

/***/ 111:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	// 通用网络错误显示组件
	__webpack_require__(244);
	
	exports.default = {
	    data: function data() {
	        return {
	            title: '哎呀，出错啦~',
	            content: '网络或服务可能存在问题，刷新试试吧',
	            btnContent: '刷新试试'
	        };
	    },
	
	    props: {
	        errorShow: {
	            type: Boolean,
	            default: false
	        }
	    },
	    methods: {
	        retry: function retry() {
	            window.location.reload();
	        }
	    }
	};

/***/ }),

/***/ 112:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	//
	//
	//
	//
	//
	//
	
	// toast信息提示
	exports.default = {
	    replace: true,
	    props: {
	        showMessage: String, // toast显示的内容
	        isShow: Boolean // toast是否显示
	    },
	    computed: {
	        showWidth: function showWidth() {
	            // 根据文字的内容多少来决定toast的宽度
	            if (this.showMessage && this.showMessage.length > 11) {
	                return true;
	            } else {
	                return false;
	            }
	        }
	    }
	};

/***/ }),

/***/ 244:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 267:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 268:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 338:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.errorShow) ? _c('div', [_c('div', {
	    staticClass: "networkError-frame"
	  }, [_c('div', {
	    staticClass: "network-center"
	  }, [_c('span', {
	    staticClass: "networkError-img"
	  }), _vm._v(" "), _c('p', {
	    staticClass: "network-p1",
	    domProps: {
	      "textContent": _vm._s(_vm.title)
	    }
	  }), _vm._v(" "), _c('p', {
	    staticClass: "network-p2",
	    domProps: {
	      "textContent": _vm._s(_vm.content)
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "network-btn",
	    on: {
	      "click": _vm.retry
	    }
	  }, [_c('p', {
	    domProps: {
	      "textContent": _vm._s(_vm.btnContent)
	    }
	  })])])])]) : _vm._e()
	},staticRenderFns: []}

/***/ }),

/***/ 343:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loadingShow),
	      expression: "loadingShow"
	    }],
	    staticClass: "backdrop",
	    on: {
	      "touchmove": function($event) {
	        $event.stopPropagation();
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loadingShow),
	      expression: "loadingShow"
	    }],
	    staticClass: "load-bg",
	    on: {
	      "touchmove": function($event) {
	        $event.stopPropagation();
	      }
	    }
	  })])
	},staticRenderFns: []}

/***/ }),

/***/ 347:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loadingShow),
	      expression: "loadingShow"
	    }],
	    staticClass: "backdrop"
	  }), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loadingShow),
	      expression: "loadingShow"
	    }],
	    staticClass: "load-bg"
	  }, [_vm._m(0)])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "load-toast"
	  }, [_c('span', {
	    staticClass: "load"
	  }, [_c('i'), _vm._v(" "), _c('i'), _vm._v(" "), _c('i'), _vm._v(" "), _c('i'), _vm._v(" "), _c('i'), _vm._v(" "), _c('i'), _vm._v(" "), _c('i'), _vm._v(" "), _c('i')]), _vm._v(" "), _c('span', {
	    staticClass: "load-font"
	  }, [_vm._v("正在加载...")]), _vm._v(" "), _c('span', {
	    staticClass: "load-myfen"
	  })])
	}]}

/***/ }),

/***/ 349:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.isShow),
	      expression: "isShow"
	    }],
	    staticClass: "pub-mask"
	  }, [_c('div', {
	    class: {
	      'pub-toast': true, 'pub-toast-normal': _vm.showMessage.length >= 11 ? false : true, 'pub-toast-wide': _vm.showMessage.length >= 11 ? true : false
	    },
	    attrs: {
	      "id": "toast_content"
	    },
	    domProps: {
	      "textContent": _vm._s(_vm.showMessage)
	    }
	  })])
	},staticRenderFns: []}

/***/ }),

/***/ 378:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(109)
	
	/* template */
	var __vue_template__ = __webpack_require__(343)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 379:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(267)
	
	/* script */
	__vue_exports__ = __webpack_require__(110)
	
	/* template */
	var __vue_template__ = __webpack_require__(347)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 380:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(111)
	
	/* template */
	var __vue_template__ = __webpack_require__(338)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 381:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(268)
	
	/* script */
	__vue_exports__ = __webpack_require__(112)
	
	/* template */
	var __vue_template__ = __webpack_require__(349)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 410:
/***/ (function(module, exports) {

	/* (ignored) */

/***/ })

});


// WEBPACK FOOTER //
// static/js/app.36e53cc1c563dc5f7e4c.js